import React from 'react';
import { Button } from 'react-bootstrap';
import { FaCommentDollar } from 'react-icons/fa';

type ButtonProps = React.ComponentProps<typeof Button>;
//type ButtonProps = React.PropsWithoutRef<ComponentProps<typeof Button>>;

type Props = ButtonProps & {
  text: string;
};

const ButtonOffer = ({ text, variant = 'success', onClick, ...rest }: Props) => (
  <Button style={{ minWidth: '240px' }} className="ms-2" variant={variant} onClick={onClick} {...rest}>
    <FaCommentDollar  className="mb-1" /> {` ${text}`}
  </Button>
);
export default React.memo(ButtonOffer);

